import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVCE
import {
	getApi as getApiRotaSP,
	postApi as postApiRotaSP,
	putApi as putApiRotaSP,
	deleteApi as deleteApiRotaSP,
} from 'services/rotasp/api';

// TYPES
import { ReducerAction, ReducerActionRotaSP } from 'store/modules/types';
import { PATH_PREFEITURAS_API } from 'services/rotasp/path';
import { Types } from './types';

// ACTIONS
import {
	consultaServicosSuccess,
	consultaServicosFailure,
	removeServicosSuccess,
	removeServicosFailure,
	cadastraServicosSuccess,
	cadastraServicosFailure,
	alteraServicosSuccess,
	alteraServicosFailure,
	consultaParametrosServicosSuccess,
	consultaParametrosServicosFailure,
	alteraParametrosServicosSuccess,
	alteraParametrosServicosFailure,
	IConsultaServicosRequest,
	IConsultaParametrosServicosRequest,
	ICadastraServicosRequest,
	IAlteraParametrosServicosRequest,
} from './actions';

function* consultaServicos(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: IConsultaServicosRequest } = request;

	const allowedStatus = [200, 204];

	const response = yield call(
		getApiRotaSP,
		token || '',
		PATH_PREFEITURAS_API,
		'servicos',
		payload,
		undefined,
		undefined,
		undefined,
		undefined,
		allowedStatus,
	);

	if (response.status === 200 || response.status === 204) {
		yield put(consultaServicosSuccess(response));
	} else if (response.error) {
		yield put(consultaServicosFailure(response.message));
	}
}

function* consultaParametrosServicos(request: ReducerAction) {
	const {
		token,
		payload,
	}: { token?: string; payload: IConsultaParametrosServicosRequest } = request;

	const allowedStatus = [200, 204];

	const response = yield call(
		getApiRotaSP,
		token || '',
		PATH_PREFEITURAS_API,
		`servicos/${payload.idServico}/parametros`,
		{},
		undefined,
		undefined,
		undefined,
		undefined,
		allowedStatus,
	);

	if (response.status === 200) {
		yield put(consultaParametrosServicosSuccess(response));
	} else if (response.status === 204) {
		yield put(consultaParametrosServicosFailure([]));
	} else if (response.error) {
		yield put(consultaParametrosServicosFailure(response.message));
	}
}

function* cadastraServicos(request: ReducerActionRotaSP) {
	const {
		payload,
		token,
	}: { token?: string; payload: ICadastraServicosRequest } = request;

	const response = yield call(
		postApiRotaSP,
		token || '',
		PATH_PREFEITURAS_API,
		'servicos',
		payload,
	);

	if (response.status === 201) {
		yield put(cadastraServicosSuccess(response));
	} else if (response.error) {
		yield put(cadastraServicosFailure(response.message));
	}
}

function* removeServicos(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: number } = request;

	const response = yield call(
		deleteApiRotaSP,
		token || '',
		PATH_PREFEITURAS_API,
		`servicos/${payload}`,
	);

	if (response.status === 200) {
		yield put(removeServicosSuccess(payload));
	} else if (response.error) {
		yield put(removeServicosFailure(response.message));
	}
}

function* alteraServicos(request: ReducerActionRotaSP) {
	const {
		payload,
		token,
	}: { token?: string; payload: ICadastraServicosRequest } = request;

	const body = { ...payload, id: null };
	const response = yield call(
		putApiRotaSP,
		token || '',
		PATH_PREFEITURAS_API,
		`servicos/${payload.id}`,
		body,
	);

	if (response.status === 200) {
		yield put(alteraServicosSuccess(response));
	} else if (response.error) {
		yield put(alteraServicosFailure(response.message));
	}
}

function* alteraParametrosServicos(request: ReducerAction) {
	const {
		token,
		payload,
	}: { token?: string; payload: IAlteraParametrosServicosRequest } = request;

	const idList = payload.body.map(item => {
		return item.id;
	});

	const response = yield call(
		putApiRotaSP,
		token || '',
		PATH_PREFEITURAS_API,
		`servicos/${payload.idServico}/parametros`,
		idList,
	);

	if (response.status === 200) {
		yield put(alteraParametrosServicosSuccess(payload));
	} else if (response.error) {
		yield put(alteraParametrosServicosFailure(response.message));
	}
}

export default all([
	takeLatest(Types.CONSULTA_SERVICOS, consultaServicos),
	takeLatest(Types.REMOVE_SERVICOS, removeServicos),
	takeLatest(Types.CADASTRA_SERVICOS, cadastraServicos),
	takeLatest(Types.ALTERA_SERVICOS, alteraServicos),
	takeLatest(Types.ALTERA_PARAMETROS_SERVICOS, alteraParametrosServicos),
	takeLatest(Types.CONSULTA_PARAMETROS_SERVICOS, consultaParametrosServicos),
]);
